export default __webpack_public_path__ + "static/media/n6.f98457fd.jpeg";